"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _lodash = require("lodash");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = {
    getPadding: function getPadding(props) {
        var padding = typeof props.padding === "number" ? props.padding : 0;
        var paddingObj = _typeof(props.padding) === "object" ? props.padding : {};
        return {
            top: paddingObj.top || padding,
            bottom: paddingObj.bottom || padding,
            left: paddingObj.left || padding,
            right: paddingObj.right || padding
        };
    },
    getStyles: function getStyles(style, defaultStyles) {
        var width = "100%";
        var height = "100%";
        if (!style) {
            return (0, _lodash.defaults)({ parent: { height: height, width: width } }, defaultStyles);
        }

        var data = style.data,
            labels = style.labels,
            parent = style.parent;

        var defaultParent = defaultStyles && defaultStyles.parent || {};
        var defaultLabels = defaultStyles && defaultStyles.labels || {};
        var defaultData = defaultStyles && defaultStyles.data || {};
        return {
            parent: (0, _lodash.defaults)({}, parent, defaultParent, { width: width, height: height }),
            labels: (0, _lodash.defaults)({}, labels, defaultLabels),
            data: (0, _lodash.defaults)({}, data, defaultData)
        };
    },
    evaluateProp: function evaluateProp(prop, data, active) {
        return (0, _lodash.isFunction)(prop) ? prop(data, active) : prop;
    },
    evaluateStyle: function evaluateStyle(style, data, active) {
        var _this = this;

        if (!style || !Object.keys(style).some(function (value) {
            return (0, _lodash.isFunction)(style[value]);
        })) {
            return style;
        }
        return Object.keys(style).reduce(function (prev, curr) {
            prev[curr] = _this.evaluateProp(style[curr], data, active);
            return prev;
        }, {});
    },
    getRange: function getRange(props, axis) {
        // determine how to lay the axis and what direction positive and negative are
        var isVertical = axis !== "x";
        var padding = this.getPadding(props);
        if (isVertical) {
            return [props.height - padding.bottom, padding.top];
        }
        return [padding.left, props.width - padding.right];
    },
    createAccessor: function createAccessor(key) {
        // creates a data accessor function
        // given a property key, path, array index, or null for identity.
        if ((0, _lodash.isFunction)(key)) {
            return key;
        } else if (key === null || typeof key === "undefined") {
            // null/undefined means "return the data item itself"
            return function (x) {
                return x;
            };
        }
        // otherwise, assume it is an array index, property key or path (_.property handles all three)
        return (0, _lodash.property)(key);
    },


    /**
     * @param {Object} props: axis component props
     * @returns {Boolean} true when the axis is vertical
     */
    isVertical: function isVertical(props) {
        var orientation = props.orientation || (props.dependentAxis ? "left" : "bottom");
        var vertical = { top: false, bottom: false, left: true, right: true };
        return vertical[orientation];
    },


    // for components that take single datasets
    // getData(props) { // old
    //     if (props.data) {
    //         return this.formatData(props.data, props);
    //     }
    // },

    // formatData(dataset, props, stringMap) {
    //     if (!dataset) {
    //         return [];
    //     }
    //     stringMap = stringMap || {
    //             x: this.createStringMap(props, "x"),
    //             y: this.createStringMap(props, "y")
    //         };
    //     const accessor = {
    //         x: this.createAccessor(props.x),
    //         y: this.createAccessor(props.y)
    //     };
    //
    //     return dataset.map((datum) => {
    //         const x = accessor.x(datum);
    //         const y = accessor.y(datum);
    //         const xName = typeof x === "string" ? {xName: x} : undefined;
    //         const yName = typeof y === "string" ? {yName: y} : undefined;
    //         return defaults({
    //             // map string data to numeric values, and add names
    //             x: typeof x === "string" ? stringMap.x[x] : x,
    //             y: typeof y === "string" ? stringMap.y[y] : y
    //         }, xName, yName, datum);
    //     });
    // },

    // createStringMap(props, axis) {
    //     const stringsFromData = this.getStringsFromData(props, axis);
    //     if (stringsFromData.length) {
    //         return stringsFromData.reduce((acc, string, index) => {
    //             acc[string] = index + 1;
    //             return acc;
    //         }, {});
    //     }
    //     return null;
    // },

    // getStringsFromData(props, axis) {
    //     if (!props.data) {
    //         return [];
    //     }
    //     const key = typeof props[axis] === "undefined" ? axis : props[axis];
    //     const accessor = this.createAccessor(key);
    //     const dataStrings = (props.data)
    //         .map((datum) => accessor(datum))
    //         .filter((datum) => typeof datum === "string");
    //     // return a unique set of strings
    //     return dataStrings.reduce((prev, curr) => {
    //         if (typeof curr !== "undefined" && curr !== null && prev.indexOf(curr) === -1) {
    //             prev.push(curr);
    //         }
    //         return prev;
    //     }, []);
    // },

    getPartialEvents: function getPartialEvents(events, index, childProps) {
        return events ? Object.keys(events).reduce(function (memo, eventName) {
            /* eslint max-params: 0 */
            memo[eventName] = (0, _lodash.partial)(events[eventName], _lodash.partial.placeholder, // evt will still be the first argument for event handlers
            childProps, // event handlers will have access to data component props, including data
            index, // used in setting a unique state property
            eventName // used in setting a unique state property
            );
            return memo;
        }, {}) : {};
    },
    getEvents: function getEvents(events, namespace) {
        var _this2 = this;

        var onEvent = function onEvent(evt, childProps, index, eventName) {
            if (_this2.props.events[namespace] && _this2.props.events[namespace][eventName]) {
                _this2.setState(_defineProperty({}, index, (0, _lodash.merge)({}, _this2.state[index], _this2.props.events[namespace][eventName](evt, childProps, index))));
            }
        };

        return events ? Object.keys(this.props.events[namespace]).reduce(function (memo, event) {
            memo[event] = onEvent;
            return memo;
        }, {}) : {};
    },
    getEventState: function getEventState(index, namespace) {
        return this.state[index] && this.state[index][namespace];
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/pluton-charts/lib/charts/libs/victory-gauge/src/old/victory-util/helpers.js
// module id = 1152
// module chunks = 0